import { Flex } from '@rebass/grid';
import { styled } from 'styles';

export const Container = styled(Flex)`
  height: 70px;
  width: 100%;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  padding: 0 16px;
  justify-content: space-between;
  cursor: pointer;
`;

export const Text = styled.div`
  font-size: 1.6rem;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.dirtyWhite};
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.15);
`;
